export default function Qty({ symbolQty }) {
  return (
    <div className="QtyTotalMin">
      <div className="LtpLeft">
        <div className="Ltp">LOT/SIZE</div>
        <div className="Chnage">QTY PER ORDER</div>
        <div className="Chnage">TOTAL QTY</div>
        <div className="Chnage">MIN QTY</div>
      </div>
      <div className="LtpRight">
        <div className="Ltp">
          {parseFloat(symbolQty === "" ? 0 : symbolQty.lot_size).toFixed(0)}
        </div>
        <div className="Chnage">
          {parseFloat(symbolQty === "" ? 0 : symbolQty.qty_per_order).toFixed(0)}
        </div>
        <div className="Chnage">
          {parseFloat(symbolQty === "" ? 0 : symbolQty.total_quantity).toFixed(
            0
          )}
        </div>
        <div className="Chnage">
          {parseFloat(symbolQty === "" ? 0 : symbolQty.min_qty).toFixed(0)}
        </div>
      </div>
    </div>
  );
}
